/* global require */
import './tokens.scss';

export default function tokensTabPanelDirective() {
  return {
    template: require('./tokens-tab-panel.html'),
    restrict: 'E',
    scope: {
      permissions: '<',
      policyDocumentId: '<',
      tokens: '=',
    },
    controller: 'TokensTabPanelController',
    controllerAs: 'tokensTabPanelVM',
    bindToController: true,
    replace: true,
  };
}
